'use client'


//page
import Nav from './Nav';

const posts = [
    {
        id: 1,
        title: 'Théâtre du Point du jour',
        href: 'https://pointdujourtheatre.fr/notre-proces_2',
        date: '9-10 décembre 2025',
        category: { title: 'Lyon', href: '#' },
    },
    {
        id: 2,
        title: 'Théâtre de la Cité Internationale',
        href: 'https://www.theatredelacite.com/notre-proces',
        date: '24-29 novembre 2025',
        category: { title: 'Paris', href: '#' },
    },
    {
        id: 3,
        title: 'Maison des Arts',
        href: 'https://www.u-bordeaux-montaigne.fr/fr/actualites/culture/annee-2024-2025/notre-proces.html',
        date: '24 janvier 2025',
        category: { title: 'Pessac', href: '#' },
    },
    {
        id: 4,
        title: 'Théâtre du Point du jour',
        href: 'https://pointdujourtheatre.fr/notre-proces_1',
        date: '9-10 avril 2024',
        datetime: '2020-03-16',
        category: { title: 'Lyon', href: '#' },
    },
   
]

export default function Calendrier() {

    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-32">
                        <div className="text-left">
                            <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                                Calendrier
                            </h1>
                            <div className='mt-10 w-full'>
                                    <div className="max-w-7xl px-6 lg:px-8">
                                        <div className="max-w-2xl">
                                           
                                            <div className="mt-10 space-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16">
                                                {posts.map((post) => (
                                                    <article key={post.id} className="flex max-w-xl flex-col items-start justify-between">
                                                        <div className="flex items-center gap-x-4 text-sm">
                                                            <time dateTime={post.datetime} className="text-white">
                                                                {post.date}
                                                            </time>
                                                            <a
                                                                href={post.category.href}
                                                                className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100 dark:bg-gray-800/60 dark:text-white-300 dark:hover:bg-gray-800"
                                                            >
                                                                {post.category.title}
                                                            </a>
                                                        </div>
                                                        <div className="group relative">
                                                            <h3 className="mt-3 text-lg/6 font-semibold text-white group-hover:text-white-600 dark:text-white dark:group-hover:text-white-300">
                                                                <a href={post.href} target="_blank">
                                                                    <span className="absolute inset-0" />
                                                                    {post.title}
                                                                </a>
                                                            </h3>
                                                        </div>
                                                        
                                                    </article>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
